import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { sortByAlphabet } from 'utils/array'
import { ContactsGlobalFilter } from '../types'
import Filter, { FilterOption } from 'components/organisms/AdvancedFilter'
import Accordion from 'components/molecules/Accordion'
import { useQuery } from 'react-query'
import { getContactsStatsFn } from '../../../api'

export const AdvancedFilters: FC<{
  globalFilter: ContactsGlobalFilter
  setGlobalFilter: (filterValue: any) => void
  realmId: number
}> = ({ globalFilter, setGlobalFilter, realmId }) => {
  const [t] = useTranslation()
  const { data: info } = useQuery(['contactsStats', realmId], getContactsStatsFn, {
    select: (data) => ({
      ...data,
      info: {
        role: (data.info.role || []).sort((a, b) => sortByAlphabet(a.value?.toString(), b.value?.toString())),
        cabinet: (data.info.cabinet || []).sort((a, b) => sortByAlphabet(a.value?.toString(), b.value?.toString())),
      },
    }),
    ///keepPreviousData: false,
  })

  const handleChangeAdvancedFilter = ({ info, visibility }: { info?: string | null; visibility?: string | null }) => {
    setGlobalFilter({
      ...globalFilter,
      info,
      visibility,
    })
  }

  return (
    <Filter>
      <Accordion
        title={t('common.cabinet')}
        items={(info?.info?.cabinet ?? []).map((cabinet) => (
          <FilterOption
            key={cabinet.value}
            filterName={cabinet.value}
            count={cabinet.count}
            isSelected={globalFilter.info === cabinet.value}
            onClick={() =>
              handleChangeAdvancedFilter({ info: globalFilter.info === cabinet.value ? '' : cabinet.value })
            }
          />
        ))}
      />
      <Accordion
        title={t('common.role')}
        items={(info?.info?.role || []).map((role) => (
          <FilterOption
            key={role.value}
            filterName={role.value}
            count={role.count}
            isSelected={globalFilter.info === role.value}
            onClick={() => handleChangeAdvancedFilter({ info: globalFilter.info === role.value ? '' : role.value })}
          />
        ))}
      />
      <Accordion
        title={t('common.visibility')}
        items={[
          <FilterOption
            key={'not_visible'}
            filterName={t('common.notVisible')}
            count={info?.visible?.not_visible_count ?? 0}
            isSelected={globalFilter.visibility === 'false'}
            onClick={() =>
              handleChangeAdvancedFilter({ visibility: globalFilter.visibility === 'false' ? '' : 'false' })
            }
          />,
          <FilterOption
            key={'visible'}
            filterName={t('common.visible')}
            count={info?.visible?.visible_count ?? 0}
            isSelected={globalFilter.visibility === 'true'}
            onClick={() =>
              handleChangeAdvancedFilter({ visibility: globalFilter.visibility === 'false' ? '' : 'false' })
            }
          />,
        ]}
      />
    </Filter>
  )
}

export const initialContactsGlobalFilter = {
  info: '',
  visibility: '',
}
